
const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  gestureHandling: "cooperative",
  mapTypeControl: false,
  zoomControlOptions: {
    style: "SMALL"
  },
  zoom: 11,
  minZoom: 2
};



export {
  mapSettings,
};
